export const SUBMITTING = 'cart.button.submitting';
export const REDIRECTING = 'cart.button.redicting';
export const SAVE = 'cart.button.save';
export const CANCEL = 'cart.button.cancel';
